import { Paths } from './paths/paths';
import { cameliseDeep } from '@utils/functions/camelise';
import { apiSlice } from './apiSlice';
import { InvestmentIntentSuccess } from './response/Investment';
import {
  GetInvestmentIntent,
  UpdateInvestmentIntent,
  CreateInvestmentIntent,
} from './request/InvestmentIntent';
import {
  InvestmentIntent,
  MinimumInvestmentAmount,
} from './response/InvestmentIntent';
import { EmbeddedDocumentSigning } from './response/DocumentSigning';
import {
  EmbeddedDocumentSigning as EmbeddedDocumentSigningRequest,
  ExternalDocumentSigning as ExternalDocumentSigningRequest,
} from './request/EmbeddedDocumentSigning';

export const investmentSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMinimumInvestmentAmount: builder.query<MinimumInvestmentAmount, void>({
      query: () => {
        return {
          url: Paths.MinimumInvestmentAmount,
          method: 'GET',
        };
      },
      transformResponse: (data: unknown) =>
        cameliseDeep<MinimumInvestmentAmount>(data),
    }),
    getInvestmentIntent: builder.query<InvestmentIntent, GetInvestmentIntent>({
      query: (arg) => {
        const { productId } = arg;
        return {
          url: Paths.InvestmentIntent,
          params: { productId },
          method: 'GET',
        };
      },
      providesTags: ['investment_intent'],
    }),
    updateInvestmentIntent: builder.mutation<
      InvestmentIntentSuccess,
      UpdateInvestmentIntent
    >({
      query: (data) => ({
        url: Paths.InvestmentIntent,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['investment_intent'],
    }),
    createInvestmentIntent: builder.mutation<
      InvestmentIntentSuccess,
      CreateInvestmentIntent
    >({
      query: (data) => ({
        url: Paths.InvestmentIntent,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['investment_intent'],
    }),
    getEmbeddedContract: builder.query<
      EmbeddedDocumentSigning,
      EmbeddedDocumentSigningRequest
    >({
      query: (data) => {
        return {
          url: Paths.GetEmbeddedContract,
          method: 'POST',
          body: data,
        };
      },
    }),
    getExternalContract: builder.query<
      EmbeddedDocumentSigning,
      ExternalDocumentSigningRequest
    >({
      query: (data) => {
        return {
          url: Paths.GetExternalContract,
          method: 'POST',
          body: data,
        };
      },
    }),
  }),
});

export const {
  useGetInvestmentIntentQuery,
  useGetMinimumInvestmentAmountQuery,
  useLazyGetInvestmentIntentQuery,
  useUpdateInvestmentIntentMutation,
  useCreateInvestmentIntentMutation,
  useGetEmbeddedContractQuery,
  useGetExternalContractQuery
} = investmentSlice;
